import React, { useState } from "react"
import PDF from "@/public/icons/PDF-ANN.svg"
import Downlaod from "@/public/icons/download-dark-gray.svg"
import InfoIcon from "@/public/icons/info.svg"
import { sanitizeInnerHtml } from "@/utils/helper";
import { SHIPS_IN_LABEL } from "@/constants/index";
import { useSelector } from "react-redux";
import { selectPdpState } from "@/store/features/pdpSlice";
const LeadTime = props => {
const { leadTimeData, leadTimeRange = "" } = props
const leadTimeDocumentLabel = "Lead time & shipping guidelines"
const [showShippingTooltip, setShowShippingTooltip] = useState(false)
const { leadTimeTab } = useSelector(selectPdpState)

return (
  <div className="content-row">
    <div className="col-text"> 
    <div className="shipping-status">
          <span className="shipping-status__shipping-time">{SHIPS_IN_LABEL + " " + leadTimeRange}</span>
          <span
          className="product-summary__shipping-tooltip-block"
          onMouseEnter={() => setShowShippingTooltip(true)}
          onMouseLeave={() => setShowShippingTooltip(false)}
        >
          <img
            src={InfoIcon?.src}
            role="tooltip"
            tabIndex={0}
            className="shipingtooltip_leadtime"
            alt="Shipping Info"
          />
          { showShippingTooltip && (
            <div className="tooltipWrapperleadtime">
              <div className="tooltip__containerleadtime"
              dangerouslySetInnerHTML={{
                __html: leadTimeTab?.shippingInfoTooltip || "<p>No information available</p>",
              }}>
              </div>
            </div>
          )}
          </span>
      </div>
      <p>{sanitizeInnerHtml(leadTimeTab?.leadTimeDescription) || "No description available"}</p>
    </div>
    
    <div className="col-pdf pdfList">
      <div className="files">
        <a
          title={leadTimeDocumentLabel}
          href={leadTimeData?.leadTimeDocumentURL}
          target="_blank"
          className="uploadFile"
          rel="noreferrer"
        >
        <span className="pdfWrapper">
          <img src={PDF?.src} />
          <span>{leadTimeDocumentLabel}</span> {/* Need to revisit this text */}
        </span>
        <img src={Downlaod?.src} />
        </a>
      </div>
    </div>
  </div>
  )
}

export default LeadTime
